<div style="display: flex; flex-direction: column; height: 100%" *ngIf="!fullScreen">
  <div style="padding: 0 0 15px 0">
    <label style="float: left; margin: 0 10px 0 100px" class="switch switch-pill switch-success switch-custom"
      ><input [(ngModel)]="showRelated" class="switch-input" type="checkbox" /><span
        class="switch-slider slider-custom"></span
    ></label>

    <div style="float: left; font-weight: 500">
      Show images from linked questions
      <a
        style="margin-left: 30px"
        *ngIf="pictures[currentPicture]?.related"
        [routerLink]="'/inspection/review/main/' + answer?.inspectionId"
        [queryParams]="getLinkParams(pictures[currentPicture])"
        >Go to original question</a
      >
    </div>
    <br style="clear: both" />
  </div>
  <div style="flex: 5">
    <app-picture-viewer
      #viewerSmall
      [picture]="pictures[currentPicture]"
      [flags]="currentFlags"
      [placeholderFlag]="placeholderFlag"
      (addFlag)="addFlag($event)"
      (editFlag)="editFlag($event)"
      (moveFlag)="moveFlag($event)"
      (markupChanged)="onMarkupChanged($event)"
      (changeFullscreen)="toggle()"
      [isFullscreen]="fullScreen">
    </app-picture-viewer>
  </div>

  <div style="position: relative">
    <div style="display: inline-grid; padding: 10px 25px; min-width: 100%">
      <div class="thumbs small" [perfectScrollbar] #thumbsContainer>
        <div
          class="thumb"
          *ngFor="let o of pictures; index as i"
          [ngClass]="{ current: currentPicture == i }"
          (click)="currentPicture = i">
          <div style="display: flex">
            <div class="thumb-border">
              <img-ajax [src]="o.Location" #thumb> </img-ajax>
            </div>
          </div>
          <span *ngIf="o.from == 'web'" class="remove-image" (click)="removeImage(o)" href="javascript:void(0)">x</span>
          <span class="related aru-has-tooltip" *ngIf="o.related">
            <span
              class="aru-tooltip"
              style="
                color: #fff;
                width: 200px;
                white-space: break-spaces;
                top: 0px;
                left: -100px;
                background-color: #444;
              "
              >{{ o.path }}</span
            >
            <i class="fa fa-chain"></i>
          </span>
        </div>
        <div style="display: inline-block">
          <div style="display: flex">
            <a class="add-image" (click)="addImage()" href="javascript:void(0)"><i class="fa fa-plus"></i> Add image</a>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="pictures.length > 1" style="position: absolute; top: 45%; width: 100%">
      <i
        *ngIf="currentPicture > 0"
        (click)="prev()"
        class="fa fa-chevron-left"
        style="font-size: 25px; position: absolute; top: 45%; left: 0; cursor: pointer; color: #3465c4"></i>

      <i
        *ngIf="hasNext()"
        (click)="next()"
        class="fa fa-chevron-right"
        style="font-size: 25px; position: absolute; top: 45%; right: 0px; cursor: pointer; color: #3465c4"></i>
    </div>
  </div>
</div>

<div
  *ngIf="fullScreen"
  style="
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000;
    z-index: 1020;
    display: flex;
  ">
  <div
    style="overflow: auto; position: relative; flex-direction: column"
    [ngStyle]="{ flex: showFlags ? flexValue : '1' }">
    <app-picture-viewer
      #viewerFull
      [picture]="pictures[currentPicture]"
      [flags]="currentFlags"
      [placeholderFlag]="placeholderFlag"
      (addFlag)="addFlag($event)"
      (editFlag)="editFlag($event)"
      [flagsWithTooltip]="flagsWithTooltip"
      (moveFlag)="moveFlag($event)"
      (markupChanged)="onMarkupChanged($event)"
      [updateImage]="updateImage"
      (changeFullscreen)="toggle()"
      [isFullscreen]="fullScreen"></app-picture-viewer>

    <!-- Back button is rendered on document.body via attachBodyExitButton() for reliable z-index. -->

    <div class="flag-panel">
      <a
        class="notification-flags"
        (click)="unpinnedFlagsCount() !== 0 && toggleFlags()"
        [class.disabled-link]="unpinnedFlagsCount() === 0">
        <i
          class="fa fa-flag fa-1x icon-styling"
          [ngStyle]="{ color: unpinnedFlagsCount() === 0 ? '#bbbbbb' : '#464646FF' }"></i>
        <span *ngIf="unpinnedFlagsCount() > 0" class="badge">{{ unpinnedFlagsCount() }}</span>
      </a>
    </div>

    <div *ngIf="pictures.length > 1">
      <i
        *ngIf="currentPicture > 0"
        (click)="prev()"
        class="fa fa-chevron-left"
        style="
          font-size: 30px;
          position: absolute;
          color: white;
          top: 45%;
          cursor: pointer;
          padding: 10px;
          z-index: 400;
          margin-left: 10px;
        "></i>

      <i
        *ngIf="hasNext()"
        (click)="next()"
        class="fa fa-chevron-right"
        style="
          font-size: 30px;
          position: absolute;
          color: white;
          top: 45%;
          right: 20px;
          cursor: pointer;
          padding: 10px;
          z-index: 400;
        "></i>
    </div>

    <div
      style="
        z-index: 400;
        position: absolute;
        bottom: 10px;
        left: 110px;
        padding: 25px;
        font-size: 15px;
        text-shadow:
          0 0 10px #000,
          0 0 10px #000,
          0 0 10px #000,
          0 0 10px #000;
        color: #fff;
      ">
      {{ formattedDateTime(currentPictureFlagDate) }} &nbsp; | &nbsp; Flags: {{ answerFlagsDisplayCount }}
    </div>
  </div>
  <div [ngStyle]="pictures.length > 1 ? { width: '250px', position: 'relative' } : {}">
    <div style="display: flex; flex-direction: column; height: 100%">
      <div
        style="padding: 10px 30px; flex: 1; white-space: normal; text-align: center"
        *ngIf="pictures.length > 1"
        class="thumbs big"
        [perfectScrollbar]>
        <div
          class="thumb"
          *ngFor="let o of pictures; index as i"
          [ngClass]="{ current: currentPicture == i }"
          (click)="currentPicture = i"
          style="max-height: none">
          <img-ajax [src]="o.Location" #thumb></img-ajax>
          <span class="related" *ngIf="o.related"><i class="fa fa-chain"></i></span>
        </div>
      </div>
    </div>
  </div>
  <div id="right-column" *ngIf="showFlags" [ngStyle]="{ flex: showFlags ? rightColumnFlexValue : '0' }">
    <app-unpinned-flags
      [picture]="pictures[currentPicture]"
      (flagPinned)="attachFlagToPictureFull($event)"
      (close)="closeFlags()"
      [pictureAnswer]="answer">
    </app-unpinned-flags>
  </div>
</div>

<app-add-flag #addFlagModal></app-add-flag>
<app-edit-flag #editFlagModal></app-edit-flag>
<app-upload-image #uploadImageModal [inspectionId]="answer.inspectionId"></app-upload-image>
